module.exports = __webpack_public_path__ + "img/icon-boolean-blue.b4302b3d.svg";